import { Injectable, signal } from '@angular/core'

/**
 * Shared shell-layout state. Lets the header hamburger (GRC theme) and the
 * in-sidebar collapse chevron (classic) drive the SAME desktop sidebar
 * collapse without coupling HeaderComponent to ShellComponent.
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly _sidebarCollapsed = signal<boolean>(false)

  readonly sidebarCollapsed = this._sidebarCollapsed.asReadonly()

  setSidebarCollapsed(collapsed: boolean): void {
    this._sidebarCollapsed.set(collapsed)
  }

  toggleSidebar(): void {
    this._sidebarCollapsed.update((v) => !v)
  }
}
